<template>
  <div :class="['user-layout-wrapper', device]" id="userLayout">
    <div class="_container">
      <div class="app-nav">
        <span class="link-title">APP下载</span>
        <span
          @click="downloadApp('Android')"
          @mousemove="AndroidDownloadShow = true"
          @mouseout="AndroidDownloadShow = false"
          class="link"
        >Android</span>
        <!-- /
        <span
          @click="downloadApp('iOS')"
          @mousemove="iosDownloadShow = true"
          @mouseout="iosDownloadShow = false"
          class="link"
          >iOS</span
        >-->
        <img alt="Android APP下载链接" class="float-img" src="/Android_download.png" v-show="AndroidDownloadShow" />
        <img alt="ios APP下载链接" class="float-img" src="/iOS_download.png" v-show="iosDownloadShow" />
      </div>

      <div class="top">
        <div class="header inline-flex">
          <!-- <img class="logo" src="~@/assets/logo.png" /> -->
          <span class="title">智能加水机系统管理平台</span>
        </div>
      </div>

      <route-view></route-view>

      <div class="footer">
        <div class="links">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2022016706号-1</a>
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <img alt="可信网站，身份验证" src="~@/assets/knet.png" style="display:inline;" />
          </a>
        </div>
        <!-- <div class="copyright">
          版权所有 &copy;
          <span>北京加艾数据技术有限公司</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from '@/components/layouts/RouteView'
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: 'UserLayout',
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {
        AndroidDownloadShow: false,
        iosDownloadShow: false
      }
    },
    mounted () {
      document.body.classList.add('userLayout')
      let customer = {
        name: 'Carl',
        details: { age: 82 }
      }
      let customerCity = customer?.city ?? '123'
      console.log(customerCity) // 123
    },
    methods: {
      downloadApp (type) {
        var fileSuffix = type.toLowerCase() === 'ios' ? 'ipa' : 'apk'
        window.open('/resource/智能加水机.' + fileSuffix)
      }
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    }
  }
</script>

<style lang="less" scoped>
  .app-nav {
    right: 30px;
    color: #fff;
    position: fixed;
    top: 50px;
    right: 100px;
  }

  .link-title {
    margin-right: 10px;
  }

  .link {
    text-decoration: underline;
    cursor: pointer;
    margin: 0 3px;
  }

  .link:hover {
    color: aqua;
  }

  .float-img {
    position: absolute;
    right: 0px;
    top: 42px;
    width: 160px;
    z-index: 9999;
  }

  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      ._container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    ._container {
      width: 100%;
      min-height: 100%;
      // background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background: #f0f2f5 url(~@/assets/bg.jpg) no-repeat 50%;
      background-size: cover;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            // color: rgba(0, 0, 0, .85);
            color: #f0f2f5;
            font-family: 'Chinese Quote', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
              'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
              'Segoe UI Symbol';
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
